import React from "react";
import { Link } from "react-router-dom";
import $ from 'jquery';

import './Navbar.css';

const Navbar = () => {

  const classNavbar = "navbar navbar-expand-xl navbar-dark bg-primary text-light fixed-top font-weight-light p-xl-2 shadow",
    classLogo = "logo navbar-brand text-nowrap d-xl-none",
    classLogoXL = "logo navbar-brand text-nowrap d-none d-xl-inline-block";

  return (
    <nav className={classNavbar}>
      <div className="container-fluid">
        <Link to="/" className={classLogo} onClick={() => $('#navigation-menu').removeClass('show')}><small>Advanced Copy Center, Inc.</small></Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation-menu" aria-controls="navigation-menu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div id="navigation-menu" className="collapse navbar-collapse justify-content-between align-items-start">
          <Link to="/" className={classLogoXL} onClick={() => $('#navigation-menu').removeClass('show')}><small>Advanced Copy Center, Inc.</small></Link>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/booklets" className="nav-link" onClick={() => $('#navigation-menu').removeClass('show')}><small>Booklets Printing and Binding</small></Link>
            </li>
            <li className="nav-item">
              <Link to="/business-cards" className="nav-link" onClick={() => $('#navigation-menu').removeClass('show')}><small>Business Cards &amp; Postcards Orders</small></Link>
            </li>
            <li className="nav-item">
              <Link to="/printing" className="nav-link" onClick={() => $('#navigation-menu').removeClass('show')}><small>B/W &amp; Color Digital Printing</small></Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={() => $('#navigation-menu').removeClass('show')}><small>Contact Us</small></Link>
            </li>
          </ul>
          <div className="navbar-text">
            <small>
              <span className="text-nowrap">Chat with our Team Now</span><br />
              <span className="text-nowrap mr-2">(212) 388-1001</span>
              <span className="mr-2"> | </span> 
              <span className="text-nowrap text-lowercase">info@accincnyc.com</span> 
            </small>
          </div>          
        </div>
      </div>
    </nav>
  );  
}

export default Navbar;